import React from 'react'
import authorsData from "../../data/authors.json"

function ShowAuthor ({ author, clickable }) {

  function LinkAuthors(author) {   
    authorsData.map(function(item) { 
      var regEx = new RegExp(item, "ig")
      var replaceMask = `<a href='/#/search?q=author: ${item}&sortOrder=Newest'>${item}</a>`
      author = author.replace(regEx, replaceMask)
    })       
    return author
  }

  return (
    <>
      {author.length > 0 ? (
        <div className='article-author' dangerouslySetInnerHTML={
            clickable ? {__html: 'By ' + LinkAuthors(author)} 
            : {__html: 'By ' + author}} />
      ) : null}
    </>
  )
}

export default ShowAuthor
